<template>
  <div>
    <JdsSidePanel :removeHorizontalClass="true" @close="$emit('close')">
      <template #header>
        <div>Rate & Review</div>
      </template>
      <template #body>
        <div class="fe-mt-m fe-mb-m fe-spacing-horizontal">
          <RatingSummary />
        </div>
        <div class="fe-mb-m fe-spacing-horizontal">
          <RatingCta />
        </div>

        <div class="fe-mb-m fe-spacing-horizontal">
          <MyReviewList />
        </div>

        <div class="fe-mb-m">
          <GalleryList />
        </div>

        <div class="fe-spacing-horizontal">
          <span class="fe-text-heading-xxs lg:fe-text-heading-xs">
            Product Reviews
            <span v-if="totalReviewCount">({{ totalReviewCount }})</span>
          </span>
        </div>

        <InfiniteScroll
          :is-loading-data="reviewsPageMeta.loading"
          :is-infinite-scroll="true"
          :current-page="reviewsPageMeta.current"
          :has-next="reviewsPageMeta.hasNext"
          className="fe-py-xs fe-spacing-horizontal"
          @load-more="fetchMoreReviews"
        >
          <ReviewListItem
            v-for="review in reviewsList"
            :key="review.id"
            :review="review"
            class="fe-py-base"
          />
        </InfiniteScroll>
      </template>
    </JdsSidePanel>
  </div>
</template>

<script>
  import JdsSidePanel from "@/components/DesignSystem/JdsSidePanel/JdsSidePanel.vue"
  import ReviewListItem from "@/components/ReviewAndRating/ReviewList/ReviewListItem.vue"
  import InfiniteScroll from "@/components/Utilities/InfiniteScroll/InfiniteScroll.vue"

  import RatingSummary from "@/components/ReviewAndRating/RatingSummary/RatingSummary.vue"
  import RatingCta from "@/components/ReviewAndRating/RatingCta/RatingCta.vue"
  import GalleryList from "@/components/ReviewAndRating/Gallery/GalleryList.vue"
  import MyReviewList from "@/components/ReviewAndRating/ReviewList/MyReviewList.vue"

  export default {
    components: {
      JdsSidePanel,
      ReviewListItem,
      InfiniteScroll,
      RatingSummary,
      RatingCta,
      GalleryList,
      MyReviewList,
    },
    inject: ["globalState", "getProductReviews"], // top parent component state
    computed: {
      reviewsList() {
        return this.globalState.reviews || []
      },
      reviewsPageMeta() {
        return this.globalState.reviewsPageMeta || {}
      },
      productId() {
        return this.globalState.product?.productId
      },
      totalReviewCount() {
        return this.globalState.reviewsCount || 0
      },
    },
    methods: {
      fetchMoreReviews(pageNoToBeFetched = 0) {
        this.getProductReviews(pageNoToBeFetched)
      },
    },
  }
</script>
